const {isArray, map} = lodash
const {RangeControl,Flex,ButtonGroup,Button} = wp.components;

export const UnitSize = ({field, max, min, label, units, onChange} = props)=>{
  
    const {val, unit} = field;
    // const maxVal = () =>{
    //     return unit == "%" ? 100 : 500;
    //  }
    //   const valuetext = (value) => {
    //     return `${value}` + unit;
    //   }
    return (
        <>

          <Flex style={{marginTop: '8px', marginBottom: '8px'}}>  
              <div>{label}</div>
              <ButtonGroup>
                  {units && isArray(units) && map(units, function(item){
                     return <Button isSmall isPrimary={unit == item} onClick={()=> onChange({...field, unit : item })}>{item}</Button>
                  }) }
            </ButtonGroup>                               
            </Flex>
        <RangeControl                      
                     //   label="Radious"
                        value={ val }
                        onChange={ ( val ) => onChange({...field, val : val}) }
                        min={ min }
                        max={ max }
                    />             
      </>
    );

}